var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktokPositive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 681.6 725.6",
    style: {
      enableBackground: "new 0 0 681.6 725.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M359,31.1c-0.4,3.9-0.8,7.9-0.8,11.8c-0.8,149.3-1.6,299-2.4,448.3c0,7.1,0.4,15-2,21.3c-16.5,46.5-63.4,72.9-111.5,63.4 c-44.1-8.7-68.2-44.5-65-97.3c2.4-43.3,29.9-73.3,72.9-79.2c15.4-2,30.7-3.2,45.7-4.7c0-40.2,0-78.4,0-121.7 c-30.3,2.4-59.9,0.4-87.1,7.1C100.6,306.8,33.6,427.4,67.5,549.1c22.8,82.3,94.9,136.3,184.8,144.6 c113.5,10.6,211.2-76.8,212.7-190.3c0.8-55.9,1.6-111.5,2-167.4c0.4-25.6,0-51.6,0-80c74.8,40.6,115,53.6,156,51.2 c0-37,0-74.1,0-111.1c-42.9-4.7-81.2-17.7-109.5-49.6c-28-31.9-42.5-70.1-44.5-115.4C432.7,31.1,396.8,31.1,359,31.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokPositive);
export default __webpack_public_path__ + "static/media/tiktok-positive.1d333d5610eb0f02795660d87c040e10.svg";
export { ForwardRef as ReactComponent };